import { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Swal from 'sweetalert2';
import { clientAxios } from '../../config/axios';
import { RefreshToken } from './types';

export const menu = async (): Promise<any> => {
  try {
    const authStr = `Bearer ${localStorage.getItem('token')}`;
    const response = await clientAxios.get('Menu', {
      headers: {
        "Content-Type": "application/json",
        Authorization: authStr
      }
    });

    switch (response.status) {
      case 200:
        return response.data;
      case 401:
        console.log("unauthorized..");
        localStorage.removeItem("token");
        window.location.href = "/login";

        return false;
      default:
        console.log("error authentication..");
        localStorage.removeItem("token");
        window.location.href = "/login";
        return false;
    }
  } catch (error) {
    if (error.response.status === 403) {
      Swal.fire({
        icon: 'warning',
        title: 'No tienes roles asignados',
        text: 'Comunícate con tu líder para su gestión.',
        confirmButtonText: 'OK'
      }).then((result) => {
        if (result.isConfirmed || result.dismiss === Swal.DismissReason.backdrop) {
          localStorage.removeItem("token");
          window.location.href = "/login";
        }
      });
      return false;
    }
    console.log(error);
    localStorage.removeItem("token");
  }
};

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  iconSubTittleModule: {
    paddingLeft: 15
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: 240,
    width: `calc(100% - ${240}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: 240,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: 240,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    backgroundColor: 'var(--st-blue)',
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  menuIcon: {
    color: 'white',
  }
}),
);

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("scopes");
  window.location.href = '/login';
}

export const parseJwt = (token: String) => {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

export const validateSourceViewPage = () => {
  const url_string = window.location.href;
  const url = new URL(url_string);
  let src = url.searchParams.get("src") ?? null;

  return src;
}

export const getRefreshToken = async (): Promise<boolean> => {
  try {
    const refreshTokendata = localStorage.getItem('refreshToken') as String;
    const refreshTokenBody: RefreshToken = {
      refreshToken: refreshTokendata.toString()
    };
    const response = await clientAxios.post(
      'Authentication/Refresh',
      refreshTokenBody,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    ).then((res) => {
      switch (res.status) {
        case 200:
          let data = res.data;
          localStorage.setItem('token', data.accessToken);
          localStorage.setItem('refreshToken', data.refreshToken);
          return true;

        default:
          return false;

      }
    }).catch((err) => {
      console.log(err);
      return false;
    }
    );

    return response;

  } catch (error) {
    console.log(error);
    return false;
  }
}

export const beforeUrlLogin = () => {
  const url_string = window.location.pathname;
  if (!url_string.includes('/login'))
    localStorage.setItem('beforeUrlLogin', url_string);
}

export const isExpireToken = async (): Promise<boolean> => {
  try {
    const token = localStorage.getItem('token') as String;
    const jwt = parseJwt(token.toString());
    if (jwt.exp < Date.now() / 1000) {
      beforeUrlLogin();
      let src = validateSourceViewPage();
      if (src != null) {
        const refreshToken = localStorage.getItem('refreshToken') as String;
        const jwtRefresh = parseJwt(refreshToken.toString());
        if (jwtRefresh.exp < Date.now() / 1000) {
          return false;
        } else {
          return await getRefreshToken();
        }
      } else {
        return false;
      }
    }
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
}